import {
  MEETING_STATUS,
  ScheduledMeetingResourceTypeMappings,
} from '@aa/nest/resource';
import {
  meetingStatusLabels,
  meetingStatusColors,
} from '@aa/nest/resource/objects';
import { computeTextColorForBackground, formatDateTime } from '@aa/ts/common';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'aa-meeting-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './meeting-card.component.html',
  styleUrl: './meeting-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingCardComponent {
  @Input({ required: true })
  meeting!: ScheduledMeetingResourceTypeMappings['resourceWithRelationsT'];

  formatDateTime = formatDateTime;

  getMeetingStatusLabel() {
    return meetingStatusLabels[this.meeting.status as MEETING_STATUS];
  }

  getMeetingStatusColor() {
    return meetingStatusColors[this.meeting.status as MEETING_STATUS];
  }

  getMeetingStatusTextColor() {
    return computeTextColorForBackground(this.getMeetingStatusColor());
  }
}
